export default "__VITE_ASSET__8b69098a__"